// React Admin 4.x uses string constants instead of imported constants

import {
    mapGetListAlertsData,
    mapGetListAgenciesData,
    mapGetListArticlesData,
    mapGetListCategoriesData,
    mapGetListCollateralsData,
    mapGetListFieldManagementNewsData,
    mapGetListGuidesData,
    mapGetListHomeBannersData,
    mapGetListHomeArticlesData,
    mapGetListJobAidsData,
    mapGetListPlatformsData,
    mapGetListProductsData,
    mapGetListProductUpdatesData,
    mapGetListImpactingPoliciesData,
    mapGetListSimplePageData,
    mapGetListSocialSharingsData,
    mapGetListTrainingsData,
    mapGetListHomeLinksData,
    mapGetListWebinarsData,
    mapGetListWritingCompaniesData,
    mapGetListRedirectsData,
    mapGetListRolesData,
    mapGetListBrandsData,
    mapGetListCoBrandedVideoCategoriesData,
    mapGetListCoBrandedVideoLogosData,
    mapGetListCoBrandedVideoTemplatesData,
    mapGetListCoBrandedVideoRequestsData,
    mapGetListCollateralCategoriesData,
    mapGetListCollateralPricesData,
    mapGetListCollateralTemplatesData,
    mapGetListCollateralDigitalAssetsData,
    mapGetListCollateralTemplateSuggestionsData,
    mapGetListCollateralRequestsData,
    mapGetListTagsData,
    mapGetListPremierAccessGroupsData,
    mapGetListPremierAccessGroupsImportsData,
    mapGetListAgencyLocationsData,
    mapGetListCustomerListsData,
    mapGetListFeedItemsData,
    mapGetListPremierAccessGroupsSpendingData,
    mapGetListPremierAccessGroupUsersSpendingData,
    mapGetListUserProductsAuthorityImportsData,
    mapGetListBannersData,
    mapGetManyWritingCompaniesData,
    mapGetOneAlertData,
    mapGetOneAgencyData,
    mapGetOneArticleData,
    mapGetOneCategoryData,
    mapGetOneCollateralData,
    mapGetOneFieldManagementNewsData,
    mapGetOneGuideData,
    mapGetOneHomeBannerData,
    mapGetOneJobAidData,
    mapGetOnePlatformData,
    mapGetOneProductData,
    mapGetOneProductUpdateData,
    mapGetOneImpactingPolicyData,
    mapGetOneSimplePageData,
    mapGetOneSocialSharingsData,
    mapGetOneTrainingData,
    mapGetOneHomeLinkData,
    mapGetOneUserData,
    mapGetOneWebinarData,
    mapGetOneRedirectData,
    mapGetOneRoleData,
    mapGetOneBrandData,
    mapGetOneCoBrandedVideoCategoryData,
    mapGetOneCoBrandedVideoLogoData,
    mapGetOneCoBrandedVideoTemplateData,
    mapGetOneCoBrandedVideoRequestData,
    mapGetOneCollateralCategoryData,
    mapGetOneCollateralPriceData,
    mapGetOneCollateralTemplateData,
    mapGetOneCollateralDigitalAssetData,
    mapGetOneCollateralRequestData,
    mapGetListCollateralLogosData,
    mapGetOneCollateralLogoData,
    mapGetOneImageData,
    mapGetOneAttachmentData,
    mapGetOneTagData,
    mapGetOnePremierAccessGroupData,
    mapGetOnePremierAccessGroupsImportData,
    mapGetOneAgencyLocationData,
    mapGetOneCustomerListData,
    mapGetOneUserProductsAuthorityImportData,
    mapGetListImportUsersHistoriesData,
    mapGetOneImportUsersHistoryData,
    mapGetOneBannerData,
    mapGetListProductPagesData,
    mapGetOneProductPageData,
} from './mappers';

import productName from '@src/utils/productName';

// eslint-disable-next-line complexity
const processResponseData = (type, resource, response, TotalCountFromHeader) => {
    // console.log(`dataProvider then ${type} ${resource} response: `, response);

    const responseData = Object.values(response)[0];
    let getListResponseData;
    let getOneResponseData = { ...responseData };
    let getManyResponseDataArray = Object.values(responseData);

    // console.log(`dataProvider then ${type} ${resource} getOneResponseData: `, getOneResponseData);
    // console.log(`dataProvider then ${type} ${resource} putResponseData: `, putResponseData);

    function handleTotal() {
        if (TotalCountFromHeader) {
            return TotalCountFromHeader;
        }

        return getListResponseData.length;
    }

    switch (type) {
        case 'getList':
            if (responseData) {
                if (Object.keys(response)[0] === 'taxonomy') {
                    getListResponseData = responseData.categories;
                } else {
                    getListResponseData = responseData;
                }
            }

            if (resource === 'alerts') {
                getListResponseData = mapGetListAlertsData(responseData);
            } else if (resource === 'agencies') {
                getListResponseData = mapGetListAgenciesData(responseData);
            } else if (resource === 'articles') {
                getListResponseData = mapGetListArticlesData(responseData);
            } else if (resource === 'attachments') {
                getListResponseData = responseData;
            } else if (resource === 'carrier_commissions') {
                getListResponseData = responseData;
            } else if (resource === 'carrier_commissions/imports') {
                getListResponseData = responseData;
            } else if (resource === 'channel') {
                getListResponseData = responseData.map((responseDatum) => {
                    return { id: responseDatum.slug, name: responseDatum.name };
                });
            } else if (resource === 'collaterals') {
                getListResponseData = mapGetListCollateralsData(responseData);
            } else if (resource === 'field_management_news') {
                getListResponseData = mapGetListFieldManagementNewsData(responseData);
            } else if (resource === 'guides') {
                getListResponseData = mapGetListGuidesData(responseData);
            } else if (resource === 'home_banners') {
                getListResponseData = mapGetListHomeBannersData(responseData);
            } else if (resource === 'featured_content') {
                getListResponseData = mapGetListHomeArticlesData(responseData);
            } else if (resource === 'images') {
                getListResponseData = responseData;
            } else if (resource === 'item_expirations') {
                getListResponseData = responseData;
            } else if (resource === 'job_aids') {
                getListResponseData = mapGetListJobAidsData(responseData);
            } else if (resource === 'page_expirations') {
                getListResponseData = responseData;
            } else if (resource === 'business_units') {
                getListResponseData = responseData.map((responseDatum) => {
                    return {
                        id: responseDatum.id,
                        name: responseDatum.name,
                    };
                });
            } else if (resource === 'platforms') {
                getListResponseData = mapGetListPlatformsData(responseData);
            } else if (resource === 'products') {
                getListResponseData = mapGetListProductsData(responseData);
            } else if (resource === 'all_products') {
                getListResponseData = mapGetListProductsData(responseData);
            } else if (resource === 'product_updates') {
                getListResponseData = mapGetListProductUpdatesData(responseData);
            } else if (resource === 'impacting_policies') {
                getListResponseData = mapGetListImpactingPoliciesData(responseData);
            } else if (resource === 'sales_channels') {
                getListResponseData = responseData.map((responseDatum) => {
                    return { id: responseDatum.slug, name: responseDatum.name };
                });
            } else if (resource === 'social_sharings') {
                getListResponseData = mapGetListSocialSharingsData(responseData);
            } else if (resource.indexOf('taxonomies/') !== -1) {
                getListResponseData = mapGetListCategoriesData(responseData);
            } else if (resource === 'trainings') {
                getListResponseData = mapGetListTrainingsData(responseData);
            } else if (resource === 'home_links') {
                getListResponseData = mapGetListHomeLinksData(responseData);
            } else if (resource === 'webinars') {
                getListResponseData = mapGetListWebinarsData(responseData);
            } else if (resource === 'states') {
                getListResponseData = responseData.map((responseDatum) => {
                    return { id: responseDatum.slug, name: responseDatum.abbreviation };
                });
            } else if (resource === 'simple_pages') {
                getListResponseData = mapGetListSimplePageData(responseData);
            } else if (resource === 'users') {
                getListResponseData = responseData;
            } else if (resource === 'writing_companies') {
                getListResponseData = mapGetListWritingCompaniesData(responseData);
            } else if (resource === 'redirect_records') {
                getListResponseData = mapGetListRedirectsData(responseData);
            } else if (resource === 'roles') {
                getListResponseData = mapGetListRolesData(responseData);
            } else if (resource === 'brands') {
                getListResponseData = mapGetListBrandsData(responseData);
            } else if (resource === 'co_branded_video_categories') {
                getListResponseData = mapGetListCoBrandedVideoCategoriesData(responseData);
            } else if (resource === 'co_branded_video_logos') {
                getListResponseData = mapGetListCoBrandedVideoLogosData(responseData);
            } else if (resource === 'co_branded_video_templates') {
                getListResponseData = mapGetListCoBrandedVideoTemplatesData(responseData);
            } else if (resource === 'co_branded_video_requests') {
                getListResponseData = mapGetListCoBrandedVideoRequestsData(responseData);
            } else if (resource === 'collateral_categories') {
                getListResponseData = mapGetListCollateralCategoriesData(responseData);
            } else if (resource === 'collateral_templates') {
                getListResponseData = mapGetListCollateralTemplatesData(responseData);
            } else if (resource === 'collateral_digital_assets') {
                getListResponseData = mapGetListCollateralDigitalAssetsData(responseData);
            } else if (resource === 'collateral_template_suggestions') {
                getListResponseData = mapGetListCollateralTemplateSuggestionsData(responseData);
            } else if (resource === 'collateral_requests') {
                getListResponseData = mapGetListCollateralRequestsData(responseData);
            } else if (resource === 'collateral_logos') {
                getListResponseData = mapGetListCollateralLogosData(responseData);
            } else if (resource === 'collateral_prices') {
                getListResponseData = mapGetListCollateralPricesData(responseData);
            } else if (resource === 'tags') {
                getListResponseData = mapGetListTagsData(responseData);
            } else if (resource === 'premier_access_groups') {
                getListResponseData = mapGetListPremierAccessGroupsData(responseData);
            } else if (resource === 'premier_access_groups_imports') {
                getListResponseData = mapGetListPremierAccessGroupsImportsData(responseData);
            } else if (resource === 'agency_locations') {
                getListResponseData = mapGetListAgencyLocationsData(responseData);
            } else if (resource === 'customer_lists') {
                getListResponseData = mapGetListCustomerListsData(responseData);
            } else if (resource === 'feed_items') {
                getListResponseData = mapGetListFeedItemsData(responseData);
            } else if (resource === 'premier_access_groups_spending') {
                getListResponseData = mapGetListPremierAccessGroupsSpendingData(responseData);
            } else if (resource === 'premier_access_group_users_spending') {
                getListResponseData = mapGetListPremierAccessGroupUsersSpendingData(responseData);
            } else if (resource === 'user_products_authority_imports') {
                getListResponseData = mapGetListUserProductsAuthorityImportsData(responseData);
            } else if (resource === 'import_users_histories') {
                getListResponseData = mapGetListImportUsersHistoriesData(responseData);
            } else if (resource === 'mulesoft_exports' || resource === 'announcements_exports' || resource === 'schedules' || resource === 'schedules/announcement_reports') {
                getListResponseData = responseData;
            } else if (resource === 'form_entries' || resource === 'quote_inquiries' || resource === 'holiday_gift_requests') {
                getListResponseData = responseData;
            } else if (resource === 'tracked_downloads') {
                getListResponseData = responseData;
            } else if (resource === 'search_phrases' || resource === 'matching_searches') {
                getListResponseData = responseData;
            } else if (resource === 'banners') {
                getListResponseData = mapGetListBannersData(responseData);
            } else if (resource === 'product_pages') {
                getListResponseData = mapGetListProductPagesData(responseData);
            } else {
                console.error(`Unhandled resource type for GET_LIST: ${resource}`);
            }

            return {
                data: getListResponseData,
                total: handleTotal(),
            };

        case 'getOne':
            // console.log(`${type} ${resource} getOneResponseData pre: `, getOneResponseData);
            if (resource.indexOf('/categories') !== -1) {
                getOneResponseData = mapGetOneCategoryData(responseData);
            } else if (resource === 'alerts') {
                getOneResponseData = mapGetOneAlertData(responseData);
            } else if (resource === 'agencies') {
                getOneResponseData = mapGetOneAgencyData(responseData);
            } else if (resource === 'articles') {
                getOneResponseData = mapGetOneArticleData(responseData);
            } else if (resource === 'attachments') {
                getOneResponseData = mapGetOneAttachmentData(responseData);
            } else if (resource === 'carrier_commissions/imports') {
                getOneResponseData = responseData;
            } else if (resource === 'collaterals') {
                getOneResponseData = mapGetOneCollateralData(responseData);
            } else if (resource === 'field_management_news') {
                getOneResponseData = mapGetOneFieldManagementNewsData(responseData);
            } else if (resource === 'guides') {
                getOneResponseData = mapGetOneGuideData(responseData);
            } else if (resource === 'home_banners') {
                getOneResponseData = mapGetOneHomeBannerData(responseData);
            } else if (resource === 'images') {
                getOneResponseData = mapGetOneImageData(responseData);
            } else if (resource === 'job_aids') {
                getOneResponseData = mapGetOneJobAidData(responseData);
            } else if (resource === 'platforms') {
                getOneResponseData = mapGetOnePlatformData(responseData);
            } else if (resource === 'products') {
                getOneResponseData = mapGetOneProductData(responseData);
            } else if (resource === 'all_products') {
                getOneResponseData = mapGetOneProductData(responseData);
            } else if (resource === 'business_units') {
                getListResponseData = responseData.map((responseDatum) => {
                    return {
                        id: responseDatum.id,
                        name: responseDatum.name,
                    };
                });
            } else if (resource === 'product_updates') {
                getOneResponseData = mapGetOneProductUpdateData(responseData);
            } else if (resource === 'impacting_policies') {
                getOneResponseData = mapGetOneImpactingPolicyData(responseData);
            } else if (resource === 'social_sharings') {
                getOneResponseData = mapGetOneSocialSharingsData(responseData);
            } else if (resource === 'trainings') {
                getOneResponseData = mapGetOneTrainingData(responseData);
            } else if (resource === 'home_links') {
                getOneResponseData = mapGetOneHomeLinkData(responseData);
            } else if (resource === 'webinars') {
                getOneResponseData = mapGetOneWebinarData(responseData);
            } else if (resource === 'simple_pages') {
                getOneResponseData = mapGetOneSimplePageData(responseData);
            } else if (resource === 'users') {
                getOneResponseData = mapGetOneUserData(responseData);
            } else if (resource === 'redirect_records') {
                getOneResponseData = mapGetOneRedirectData(responseData);
            } else if (resource === 'roles') {
                getOneResponseData = mapGetOneRoleData(responseData);
            } else if (resource === 'brands') {
                getOneResponseData = mapGetOneBrandData(responseData);
            } else if (resource === 'co_branded_video_categories') {
                getOneResponseData = mapGetOneCoBrandedVideoCategoryData(responseData);
            } else if (resource === 'co_branded_video_logos') {
                getOneResponseData = mapGetOneCoBrandedVideoLogoData(responseData);
            } else if (resource === 'co_branded_video_templates') {
                getOneResponseData = mapGetOneCoBrandedVideoTemplateData(responseData);
            } else if (resource === 'co_branded_video_requests') {
                getOneResponseData = mapGetOneCoBrandedVideoRequestData(responseData);
            } else if (resource === 'collateral_categories') {
                getOneResponseData = mapGetOneCollateralCategoryData(responseData);
            } else if (resource === 'collateral_templates') {
                getOneResponseData = mapGetOneCollateralTemplateData(responseData);
            } else if (resource === 'collateral_digital_assets') {
                getOneResponseData = mapGetOneCollateralDigitalAssetData(responseData);
            } else if (resource === 'collateral_requests') {
                getOneResponseData = mapGetOneCollateralRequestData(responseData);
            } else if (resource === 'collateral_logos') {
                getOneResponseData = mapGetOneCollateralLogoData(responseData);
            } else if (resource === 'collateral_prices') {
                getOneResponseData = mapGetOneCollateralPriceData(responseData);
            } else if (resource === 'tags') {
                getOneResponseData = mapGetOneTagData(responseData);
            } else if (resource === 'premier_access_groups') {
                getOneResponseData = mapGetOnePremierAccessGroupData(responseData);
            } else if (resource === 'premier_access_groups_imports') {
                getOneResponseData = mapGetOnePremierAccessGroupsImportData(responseData);
            } else if (resource === 'agency_locations') {
                getOneResponseData = mapGetOneAgencyLocationData(responseData);
            } else if (resource === 'customer_lists') {
                getOneResponseData = mapGetOneCustomerListData(responseData);
            } else if (resource === 'user_products_authority_imports') {
                getOneResponseData = mapGetOneUserProductsAuthorityImportData(responseData);
            } else if (resource === 'import_users_histories') {
                getOneResponseData = mapGetOneImportUsersHistoryData(responseData);
            } else if (resource === 'mulesoft_exports' || resource === 'announcements_exports' || resource === 'schedules' || resource === 'schedules/announcement_reports' || resource === 'form_entries' || resource === 'quote_inquiries' || resource === 'holiday_gift_requests') {
                getOneResponseData = responseData;
            } else if (resource === 'tracked_downloads') {
                getOneResponseData = responseData;
            } else if (resource === 'search_phrases' || resource === 'matching_searches') {
                getOneResponseData = responseData;
            } else if (resource === 'banners') {
                getOneResponseData = mapGetOneBannerData(responseData);
            } else if (resource === 'product_pages') {
                getOneResponseData = mapGetOneProductPageData(responseData);
            } else {
                console.error(`Unhandled resource type for GET_ONE: ${resource}`);
            }

            return {
                data: getOneResponseData,
            };
        case 'create':
            if (resource.indexOf('/categories') !== -1) {
                getOneResponseData = mapGetOneCategoryData(responseData);
            } else if (resource === 'alerts') {
                getOneResponseData = mapGetOneAlertData(responseData);
            } else if (resource === 'agencies') {
                getOneResponseData = mapGetOneAgencyData(responseData);
            } else if (resource === 'articles') {
                getOneResponseData = mapGetOneArticleData(responseData);
            } else if (resource === 'collaterals') {
                getOneResponseData = mapGetOneCollateralData(responseData);
            } else if (resource === 'field_management_news') {
                getOneResponseData = mapGetOneFieldManagementNewsData(responseData);
            } else if (resource === 'guides') {
                getOneResponseData = mapGetOneGuideData(responseData);
            } else if (resource === 'home_banners') {
                getOneResponseData = mapGetOneHomeBannerData(responseData);
            } else if (resource === 'images') {
                getOneResponseData = mapGetOneImageData(responseData);
            } else if (resource === 'job_aids') {
                getOneResponseData = mapGetOneJobAidData(responseData);
            } else if (resource === 'product_updates') {
                getOneResponseData = mapGetOneProductUpdateData(responseData);
            } else if (resource === 'impacting_policies') {
                getOneResponseData = mapGetOneImpactingPolicyData(responseData);
            } else if (resource === 'products' || resource === 'all_products') {
                getOneResponseData = mapGetOneProductData(responseData);
            } else if (resource === 'reassignment') {
            // Reassignment API call doesn't return any data but
            // react admin expect an object with `id` field.
                getOneResponseData = { id: 123456 };
            } else if (resource === 'social_sharings') {
                getOneResponseData = mapGetOneSocialSharingsData(responseData);
            } else if (resource === 'trainings') {
                getOneResponseData = mapGetOneTrainingData(responseData);
            } else if (resource === 'home_links') {
                getOneResponseData = mapGetOneHomeLinkData(responseData);
            } else if (resource === 'webinars') {
                getOneResponseData = mapGetOneWebinarData(responseData);
            } else if (resource === 'simple_pages') {
                getOneResponseData = mapGetOneSimplePageData(responseData);
            } else if (resource === 'users') {
                getOneResponseData = mapGetOneUserData(responseData);
            } else if (resource === 'redirect_records') {
                getOneResponseData = mapGetOneRedirectData(responseData);
            } else if (resource === 'roles') {
                getOneResponseData = mapGetOneRoleData(responseData);
            } else if (resource === 'brands') {
                getOneResponseData = mapGetOneBrandData(responseData);
            } else if (resource === 'co_branded_video_categories') {
                getOneResponseData = mapGetOneCoBrandedVideoCategoryData(responseData);
            } else if (resource === 'co_branded_video_logos') {
                getOneResponseData = mapGetOneCoBrandedVideoLogoData(responseData);
            } else if (resource === 'co_branded_video_templates') {
                getOneResponseData = mapGetOneCoBrandedVideoTemplateData(responseData);
            } else if (resource === 'co_branded_video_requests') {
                getOneResponseData = mapGetOneCoBrandedVideoRequestData(responseData);
            } else if (resource === 'collateral_categories') {
                getOneResponseData = mapGetOneCollateralCategoryData(responseData);
            } else if (resource === 'collateral_templates') {
                getOneResponseData = mapGetOneCollateralTemplateData(responseData);
            } else if (resource === 'collateral_digital_assets') {
                getOneResponseData = mapGetOneCollateralDigitalAssetData(responseData);
            } else if (resource === 'collateral_requests') {
                getOneResponseData = mapGetOneCollateralRequestData(responseData);
            } else if (resource === 'collateral_logos') {
                getOneResponseData = mapGetOneCollateralLogoData(responseData);
            } else if (resource === 'collateral_prices') {
                getOneResponseData = mapGetOneCollateralPriceData(responseData);
            } else if (resource === 'tags') {
                getOneResponseData = mapGetOneTagData(responseData);
            } else if (resource === 'premier_access_groups_imports') {
                getOneResponseData = mapGetOnePremierAccessGroupsImportData(responseData);
            } else if (resource === 'user_products_authority_imports') {
                getOneResponseData = mapGetOneUserProductsAuthorityImportData(responseData);
            } else if (resource === 'import_users_histories') {
                getOneResponseData = mapGetOneImportUsersHistoryData(responseData);
            } else if (resource === 'mulesoft_exports' || resource === 'announcements_exports' || resource === 'schedules' || resource === 'schedules/announcement_reports' || resource === 'form_entries' || resource === 'quote_inquiries' || resource === 'holiday_gift_requests') {
                getOneResponseData = responseData;
            } else if (resource === 'tracked_downloads') {
                getOneResponseData = responseData;
            } else if (resource === 'search_phrases' || resource === 'matching_searches') {
                getOneResponseData = responseData;
            } else if (resource === 'banners') {
                getOneResponseData = mapGetOneBannerData(responseData);
            } else if (resource === 'product_pages') {
                getOneResponseData = mapGetOneProductPageData(responseData);
            } else {
                console.error(`Unhandled resource type for CREATE: ${resource}`);
            }

            return {
                data: getOneResponseData,
            };
        case 'getMany':
            // console.log(`${type} ${resource} responseData: `, responseData);
            // console.log(`${type} ${resource} getManyResponseDataArray pre: `, getManyResponseDataArray);
            if (resource === 'platforms') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.slug, name: item.name };
                });
            } else if (resource === 'products') {
                const productItems = Array.isArray(responseData) ?
                    responseData :
                    getManyResponseDataArray;
                getManyResponseDataArray = productItems
                    .filter((item) => item && typeof item === 'object' && !Array.isArray(item))
                    .map((item) => {
                        return {
                            id: item.slug || item.id,
                            business_unit_id: item.business_unit_id,
                            business_unit_name: item.business_unit_name,
                            name: productName(item.name, item.platform),
                            platform: item.platform,
                            product_line: item.product_line,
                            isNew: item.is_new,
                            states: item.available_states,
                        };
                    });
            } else if (resource === 'all_products') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return {
                        id: item.slug,
                        business_unit_id: item.business_unit_id,
                        business_unit_name: item.business_unit_name,
                        name: productName(item.name, item.platform),
                        platform: item.platform,
                        product_line: item.product_line,
                        isNew: item.is_new,
                        states: item.available_states,
                    };
                });
            } else if (resource === 'business_units') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return {
                        id: item.id,
                        name: item.name,
                    };
                });
            } else if (resource === 'states') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return {
                        id: item.slug,
                        name: item.abbreviation,
                    };
                });
            } else if (resource === 'writing_companies') {
                getManyResponseDataArray = mapGetManyWritingCompaniesData(getManyResponseDataArray);
            } else if (resource === 'roles') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'brands') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'co_branded_video_templates') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'collateral_categories') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'tags') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'collateral_logos') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'agency_locations') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name };
                });
            } else if (resource === 'customer_lists') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.id, name: item.name, attachment: item.attachment };
                });
            } else if (resource === 'premier_access_groups') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return item;
                });
            } else if (resource === 'users' || resource === 'agents') {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return {
                        id: item.id,
                        agent_code: item.agent_code,
                        producer_id: item.producer_id,
                        first_name: item.first_name,
                        last_name: item.last_name,
                        email: item.email,
                    };
                });
            } else {
                getManyResponseDataArray = getManyResponseDataArray.map((item) => {
                    return { id: item.slug, name: item.name };
                });
            }

            return {
                data: getManyResponseDataArray,
            };
        case 'updateMany':
            return { data: [] };
        case 'delete':
            return {
                data: {
                    id: responseData.slug || responseData.id,
                },
            };
        case 'deleteMany':
            return { data: [] };
        case 'update':
            if (resource.indexOf('/categories') !== -1) {
                getOneResponseData = mapGetOneCategoryData(responseData);
            } else if (resource === 'alerts') {
                getOneResponseData = mapGetOneAlertData(responseData);
            } else if (resource === 'agencies') {
                getOneResponseData = mapGetOneAgencyData(responseData);
            } else if (resource === 'articles') {
                getOneResponseData = mapGetOneArticleData(responseData);
            } else if (resource === 'attachments') {
                getOneResponseData = mapGetOneAttachmentData(responseData);
            } else if (resource === 'collaterals') {
                getOneResponseData = mapGetOneCollateralData(responseData);
            } else if (resource === 'field_management_news') {
                getOneResponseData = mapGetOneFieldManagementNewsData(responseData);
            } else if (resource === 'guides') {
                getOneResponseData = mapGetOneGuideData(responseData);
            } else if (resource === 'home_banners') {
                getOneResponseData = mapGetOneHomeBannerData(responseData);
            } else if (resource === 'images') {
                getOneResponseData = mapGetOneImageData(responseData);
            } else if (resource === 'job_aids') {
                getOneResponseData = mapGetOneJobAidData(responseData);
            } else if (resource === 'all_products' || resource === 'products') {
                getOneResponseData = mapGetOneProductData(responseData);
            } else if (resource === 'platforms') {
                getOneResponseData = mapGetOnePlatformData(responseData);
            } else if (resource === 'product_updates') {
                getOneResponseData = mapGetOneProductUpdateData(responseData);
            } else if (resource === 'impacting_policies') {
                getOneResponseData = mapGetOneImpactingPolicyData(responseData);
            } else if (resource === 'social_sharings') {
                getOneResponseData = mapGetOneSocialSharingsData(responseData);
            } else if (resource === 'trainings') {
                getOneResponseData = mapGetOneTrainingData(responseData);
            } else if (resource === 'home_links') {
                getOneResponseData = mapGetOneHomeLinkData(responseData);
            } else if (resource === 'webinars') {
                getOneResponseData = mapGetOneWebinarData(responseData);
            } else if (resource === 'simple_pages') {
                getOneResponseData = mapGetOneSimplePageData(responseData);
            } else if (resource === 'users') {
                getOneResponseData = mapGetOneUserData(responseData);
            } else if (resource === 'redirect_records') {
                getOneResponseData = mapGetOneRedirectData(responseData);
            } else if (resource === 'roles') {
                getOneResponseData = mapGetOneRoleData(responseData);
            } else if (resource === 'brands') {
                getOneResponseData = mapGetOneBrandData(responseData);
            } else if (resource === 'co_branded_video_categories') {
                getOneResponseData = mapGetOneCoBrandedVideoCategoryData(responseData);
            } else if (resource === 'co_branded_video_logos') {
                getOneResponseData = mapGetOneCoBrandedVideoLogoData(responseData);
            } else if (resource === 'co_branded_video_templates') {
                getOneResponseData = mapGetOneCoBrandedVideoTemplateData(responseData);
            } else if (resource === 'co_branded_video_requests') {
                getOneResponseData = mapGetOneCoBrandedVideoRequestData(responseData);
            } else if (resource === 'collateral_categories') {
                getOneResponseData = mapGetOneCollateralCategoryData(responseData);
            } else if (resource === 'collateral_templates') {
                getOneResponseData = mapGetOneCollateralTemplateData(responseData);
            } else if (resource === 'collateral_digital_assets') {
                getOneResponseData = mapGetOneCollateralDigitalAssetData(responseData);
            } else if (resource === 'collateral_requests') {
                getOneResponseData = mapGetOneCollateralRequestData(responseData);
            } else if (resource === 'collateral_logos') {
                getOneResponseData = mapGetOneCollateralLogoData(responseData);
            } else if (resource === 'collateral_prices') {
                getOneResponseData = mapGetOneCollateralPriceData(responseData);
            } else if (resource === 'tags') {
                getOneResponseData = mapGetOneTagData(responseData);
            } else if (resource === 'agency_locations') {
                getOneResponseData = mapGetOneAgencyLocationData(responseData);
            } else if (resource === 'customer_lists') {
                getOneResponseData = mapGetOneCustomerListData(responseData);
            } else if (resource === 'mulesoft_exports' || resource === 'announcements_exports' || resource === 'schedules' || resource === 'schedules/announcement_reports' || resource === 'form_entries' || resource === 'quote_inquiries' || resource === 'holiday_gift_requests') {
                getOneResponseData = responseData;
            } else if (resource === 'tracked_downloads') {
                getOneResponseData = responseData;
            } else if (resource === 'search_phrases' || resource === 'matching_searches') {
                getOneResponseData = responseData;
            } else if (resource === 'banners') {
                getOneResponseData = mapGetOneBannerData(responseData);
            } else if (resource === 'product_pages') {
                getOneResponseData = mapGetOneProductPageData(responseData);
            } else {
                console.error(`Unhandled resource type for UPDATE: ${resource}`);
            }

            return {
                data: getOneResponseData,
            };
        default:
            return {
                data: responseData,
            };
    }
};

export { processResponseData };
